var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 21.768,
    height: 22.25,
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-twitter"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-twitter",
    clipPath: "url(#clip-icon-twitter)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_116",
    "data-name": "Group 116",
    transform: "translate(1 1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M21.059,0c-.157.184-.312.369-.47.552L16.574,5.218Q14.787,7.3,13,9.372a.07.07,0,0,0,0,.1q1.514,2.2,3.025,4.4l3.172,4.615,2.546,3.7c.009.014.017.028.031.05l-.058,0H15.343a.088.088,0,0,1-.083-.043q-1.206-1.757-2.414-3.514l-2.157-3.139-1.3-1.892c-.01-.015-.022-.03-.036-.049l-.3.342-6.513,7.57c-.2.228-.393.455-.587.683a.107.107,0,0,1-.091.042q-.921,0-1.843,0H0v-.011A.547.547,0,0,0,.04,22.2l4.026-4.678q2.194-2.55,4.389-5.1a.076.076,0,0,0,.007-.113c-.213-.305-.423-.613-.634-.92L5.315,7.734,2.852,4.151.222.325C.15.219.074.116,0,.012,0,.008,0,0,.006,0H6.487c.011.017.021.036.033.053l2.144,3.12,3.191,4.643.25.362.1-.115L17.276,2.17,19.142,0ZM19.141,20.868c-.017-.027-.026-.041-.036-.055l-3.69-5.278-4.448-6.36Q8.281,5.334,5.6,1.491A.1.1,0,0,0,5.5,1.445H2.616c.017.026.026.042.037.057L7.223,8.04l4.908,7.02q2.014,2.88,4.027,5.761a.1.1,0,0,0,.1.048h2.884Z",
    transform: "translate(0 -0.001)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.68d484c78f1cbc0f6d78d7d48ff49c91.svg";
export { ForwardRef as ReactComponent };